"use client";
import * as React from "react";
const SvgChevronRightSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 8 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1.7 0 .3 1.41 4.88 6 .3 10.59 1.7 12l6-6z" }));
export {
  SvgChevronRightSharp as default
};
